/* eslint-disable max-len */

export const isCategoryExcluded = (parameters, categories) => parameters.categories && categories.some(c => !parameters.categories.includes(c));
